import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/incidents/{-$id}')({
  beforeLoad: () =>
    getTitleContextSlice(window.location.pathname.toLowerCase().endsWith('/identities/incidents') ? 'Incidents' : 'Incident Detail'),
  staticData: { owner: CodeOwner.IDNP },
});
